<template>
  <div class="page-message">
    <div class="message-search">
      <span class="search-label">来源：</span>
      <el-select class="search-input" v-model="source" placeholder="请选择">
        <el-option
          v-for="item in sourceList"
          :key="item"
          :label="item"
          :value="item"
        >
        </el-option>
      </el-select>
      <span class="search-label">联系人姓名：</span>
      <el-input
        class="search-input"
        size="small"
        v-model="name"
        placeholder="请输入内容"
      ></el-input>
      <span class="search-label">联系人手机号：</span>
      <el-input
        class="search-input"
        size="small"
        v-model="phone"
        placeholder="请输入内容"
      ></el-input>
      <el-button
        class="search-but1"
        size="small"
        type="primary"
        @click="handleSearch"
      >
        搜索
      </el-button>
      <el-button class="search-but1" size="small" @click="handleReset">
        重置
      </el-button>
    </div>
    <div class="message-add">
      <el-button size="small" type="primary" @click="handleExport">
        导出
      </el-button>
    </div>
    <div class="message-table">
      <el-table
        :data="messageList"
        style="width: 100%"
        :border="true"
        v-loading="loading"
        row-key="id"
      >
        <el-table-column
          v-for="item in column"
          :key="item.prop"
          :prop="item.prop"
          :label="item.label"
          align="center"
          :min-width="item.width || '100'"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          key="option"
          prop="option"
          label="操作"
          align="center"
          min-width="70"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="handleDetail(scope.row)">
              详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="message-pagination">
      <el-pagination
        @size-change="handleLimitChange"
        @current-change="handlePageChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <MessageBoardWrite
      v-if="writeDialogFlag"
      :defaultData="writeDialogData"
      :handleClose="handleCloseWriteDialog"
    />
  </div>
</template>
<script>
import * as API from '../../api/message/index'
import { column, sourceList } from './assets'
import MessageBoardWrite from './writeDialog.vue'
import { baseURL } from '@/api/request'
export default {
  name: 'MessageBoard',
  components: { MessageBoardWrite },
  data() {
    return {
      column,
      sourceList,
      name: '',
      phone: '',
      source: '',
      limit: 10,
      page: 1,
      total: 0,
      messageList: [],
      loading: false,
      writeDialogFlag: false,
      writeDialogData: {}
    }
  },
  created() {
    this.getMessageList()
  },
  methods: {
    async getMessageList() {
      this.loading = true
      try {
        const { limit, page, name, phone, source } = this
        const params = {
          limit,
          page,
          name,
          phone,
          source
        }
        const res = await API.getMessageList(params)
        const {
          code,
          data: { records = [], total }
        } = res
        if (code === 0) {
          this.messageList = records.map((item, ind) => ({
            ...item,
            sortNum: (page - 1) * limit + ind + 1
          }))
          this.total = Number(total)
        }
      } catch (error) {
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.page = 1
      this.getMessageList()
    },
    handleReset() {
      this.page = 1
      this.name = ''
      this.phone = ''
      this.source = ''
      this.getMessageList()
    },
    handleDetail(row) {
      this.writeDialogData = row
      this.writeDialogFlag = true
    },
    // 换每页条数
    handleLimitChange(limit) {
      this.limit = limit
      this.page = 1
      this.getMessageList()
    },
    // 换页
    handlePageChange(page) {
      this.page = page
      this.getMessageList()
    },
    handleExport() {
      window.open(baseURL + '/radioweb/adm/messageBoard/exportMessageBoard')
    },
    handleCloseWriteDialog(bool) {
      this.writeDialogFlag = false
      if (bool) this.getMessageList()
    }
  }
}
</script>
<style lang='scss' scoped>
.page-message {
  background: #fff;
  padding: 20px;
  .message-search {
    margin-bottom: 20px;
    .search-label {
      margin-right: 10px;
    }
    .search-input {
      width: 230px;
      margin-right: 20px;
    }
    .search-but1 {
      margin-right: 10px;
    }
    .search-but2 {
      margin-right: 10px;
    }
  }
  .message-add {
    margin-bottom: 20px;
    text-align: right;
  }
  .message-table {
    margin-bottom: 20px;
    .table-img {
      width: 100px;
      height: 20px;
      cursor: pointer;
    }
  }
}
</style>